<template>     

    <nav-bar :returnAction="true" :saveAction="activeIconNavBar" :pageName="'Cadastro de Relato'" @save="execute" @return="$router.push(`/reports`)" />

    <main-container :onlyNav="true">
       
        <div class="row w-100">            
            <div class="col-sm-12 mb-2">
                <label for="recipient-name" class="form-label">Título</label>
                <input
                type="text"
                class="form-control"
                v-model="reportStore.report.title"                      
                :disabled="disableFields"
                >
            </div>                
            <div class="col-sm-12 col-md-6 mb-2">
                <label for="recipient-name" class="form-label">Data</label>
                <input type="date" class="form-control" v-model="reportStore.report.date" :disabled="disableFields">
            </div>                                                        
            <div class="col-sm-12 col-md-6 mb-2" >
                <label for="recipient-name" class="form-label">Período</label>
                <select class="form-select" v-model="reportStore.report.period" :disabled="disableFields">
                    <option v-for="(obj, index) in validPeriods" :value="obj.key" :key="index">{{`${obj.value}`}}</option>
                </select>
            </div>                          
            
            <div class="col-sm-12 mb-1">                
                <label class="form-label">Relato</label>                  
                <textarea class="form-control textarea" v-model="reportStore.report.description" placeholder="Escreva como está se sentindo..." :disabled="disableFields"></textarea>
            </div>
        </div>               
          
    </main-container>

    <FloatHumorSelec @humor="setHumor" :activeHumor="reportStore.report.humor" :disable="disableFields" />

</template>


<script>
import FloatHumorSelec from "../../components/Humor/FloatHumorSelect.vue";
import { showErrorNotifications } from "../../services/popups";
import { useReportStore } from '@/store/report';
import { useUserStore } from '@/store/user';
import { useIdxDBStore } from '@/store/idxDB';
import { v4 as uuidv4 } from "uuid";

export default {
    name:"ReportCrudView",    
    inject:["mySpinner"],    
    components: {             
        FloatHumorSelec,        
    },  
    setup() {
        const reportStore = useReportStore();
        const userStore = useUserStore();
        const idxDBStore = useIdxDBStore();
        return { reportStore, userStore, idxDBStore}
    },       
    async mounted() {
        this.reportStore.clean();
        if (this.reportId != "create") {
            this.mySpinner.loading = true;
            await this.reportStore.getReportById(this.reportId);
            this.mySpinner.loading = false;
            this.executeMethod = "update";
            if (this.reportStore.report.viewingDate) {
                this.disableFields = true;
                this.activeIconNavBar = false;
            }
        }
        else {
            this.executeMethod = "create";
            this.reportStore.preFillFields();
        }
    },   
    props: {
        reportId:{type:String}
    },
    data() {
        return {            
            executeMethod:"",                   
            validPeriods: [{key:0, value:"Não Informado"}, {key:1, value:"Manhã"}, {key:2, value:"Tarde"}, {key:3, value:"Noite"}],
            disableFields: false,
            activeIconNavBar:true
        }
    },
    methods: {                 
        async execute() {
            if (this.executeMethod == "create") {
                await this.executeCreate();
            }
            else {
                await this.executeUpdate();
            }
        },
        async executeCreate() {

            let notifications = [];

            if (this.reportStore.report.title == "") {
                notifications.push({key:"Title", message:"O Título é obrigatório!"})
            }

            if (this.reportStore.report.date == "") {
                notifications.push({key:"Date", message:"A Data é obrigatória!"})
            }

            if (this.reportStore.report.period == 0) {
                notifications.push({key:"Perid", message:"O Período deve ser informado!"})
            }

            if (this.reportStore.report.humor == 0) {
                notifications.push({key:"Humor", message:"O Humor deve ser informado!"})
            }

            if (this.reportStore.report.description == 0) {
                notifications.push({key:"Description", message:"O Relato deve ser informado!"})
            }

            if (notifications.length > 0) { 
                showErrorNotifications(notifications);
                return;
            }
           
            this.reportStore.report.id = uuidv4();
            this.reportStore.postReport({...this.reportStore.report, patientId:this.userStore.getUser.id});                
        },
        async executeUpdate() {

            let notifications = [];

            if (this.reportStore.report.name == "") {
                notifications.push({key:"Title", message:"O Título é obrigatório!"})
            }

            if (this.reportStore.report.date == "") {
                notifications.push({key:"Date", message:"A Data é obrigatória!"})
            }

            if (this.reportStore.report.period == 0) {
                notifications.push({key:"Perid", message:"O Período deve ser informado!"})
            }

            if (this.reportStore.report.humor == 0) {
                notifications.push({key:"Humor", message:"O Humor deve ser informado!"})
            }

            if (this.reportStore.report.description == 0) {
                notifications.push({key:"Description", message:"O Relato deve ser informado!"})
            }

            if (notifications.length > 0) { 
                showErrorNotifications(notifications);
                return;
            }            

            this.reportStore.report.id = this.reportId;

            await this.reportStore.putReport(this.reportStore.report);
        },              
        setHumor(humor) {
            this.reportStore.report.humor = humor;
        },
        wantSave() {

            if (this.disableFields == false) {
                 this.$swal.fire({
                title: 'Confirmação', 
                text:'Deseja sair sem salvar o relato ?',               
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Sim',
                denyButtonText: 'Não',                
                customClass: {
                  actions: 'my-actions',                  
                  confirmButton: 'order-1',
                  denyButton: 'order-3',
                }
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$router.push("/reports");
                    }                 
                });
            }
            else {
                this.$router.push("/reports");
            }                      
        },            
    },        
}

</script>


<style lang="css" scoped>
    @import'../../assets/css/_colors';
    @import'../../assets/css/_reports';
</style>
